import { MenuItem } from './menu-item';

/**
 * Muitos `path` de MenuItem carregam a barra final legada do `MenuRoutes`
 * Angular (ex.: '/integrador/inicio/'), mas a rota real nunca tem essa barra
 * (nem o registro em `migrated-routes.ts`, nem o hash após navegação). No
 * Angular original isso nunca importava: `routerLinkActive`/`UrlTree`
 * descartam um segmento final vazio tanto do link quanto da rota corrente
 * antes de comparar. Aqui a comparação é string pura, então essa
 * normalização precisa ser explícita para preservar o mesmo comportamento.
 */
function normalizeTrailingSlash(path: string): string {
  return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
}

/**
 * Cadeia (topo→folha) do item folha ou subitem cujo `path` casa com `route`
 * (ignorando barra final em ambos os lados); `[]` quando nenhum casa. Itens
 * com submenu não são comparados por si mesmos (seu `path` não é relevante)
 * — a busca continua pelos subitens, incluindo o pai na cadeia quando o
 * subitem casa.
 */
export function findActivePath(tree: readonly MenuItem[], route: string): MenuItem[] {
  return findActivePathNormalized(tree, normalizeTrailingSlash(route));
}

function findActivePathNormalized(tree: readonly MenuItem[], normalizedRoute: string): MenuItem[] {
  for (const item of tree) {
    if (item.submenu.length > 0) {
      const childPath = findActivePathNormalized(item.submenu, normalizedRoute);
      if (childPath.length > 0) {
        return [item, ...childPath];
      }
      continue;
    }

    if (normalizeTrailingSlash(item.path) === normalizedRoute) {
      return [item];
    }
  }

  return [];
}
